import { render, staticRenderFns } from "./PromoCodesTable.vue?vue&type=template&id=1a312219&scoped=true&"
import script from "./PromoCodesTable.vue?vue&type=script&lang=js&"
export * from "./PromoCodesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a312219",
  null
  
)

export default component.exports